/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/factory_medium'
export default icon
